module.exports = __webpack_public_path__ + "static/media/jillTaylor.9cec107f.jpg";